module.exports = __webpack_public_path__ + "static/img/exporting.eb126ed3.svg";